import { FmlxCheckBox, FmlxButton } from 'fmlx-common-ui';
import React, { useState } from 'react';

type ModalCheckboxFooterProps = {
  checkboxLabel: string;
  onCancel: () => void;
  onConfirm: (checkboxValue: boolean) => void;
};

// Custom footer component used in the archiving start over modal.
// Has a checkbox whose value is returned as an arg in the confirm button callback
export const ModalCheckboxFooter = (props: ModalCheckboxFooterProps) => {
  const { checkboxLabel, onCancel, onConfirm } = props;
  const [checked, setChecked] = useState<boolean>(false);

  return (
    <div className="flex w-full h-full p-2 gap-2 border-0 border-t border-[#CACACA] border-solid">
      <div className="flex-1">
        <FmlxCheckBox
          label={checkboxLabel}
          labelPlacement={FmlxCheckBox.LabelPlacement.RIGHT}
          checked={checked}
          onChange={() => setChecked((prev) => !prev)}
        />
      </div>
      <FmlxButton
        label="CANCEL"
        type={FmlxButton.Type.BASIC}
        variant={FmlxButton.Variant.OUTLINE}
        onClick={onCancel}
      />
      <FmlxButton
        label="CONFIRM"
        type={FmlxButton.Type.PRIMARY}
        variant={FmlxButton.Variant.CONTAIN}
        onClick={() => onConfirm(checked)}
      />
    </div>
  );
};
